/** @file sampleLocals: every node's local sample of a clip at a time, with frame keys and flex filtering. */
import type { ClipChannels } from '@zilo/pose3d-pose/sample/channelTypes';
import type { LocalPose } from '@zilo/pose3d-pose/sample/localTypes';
import { nodeFrameKey } from '@zilo/pose3d-pose/sample/nodeFrameKey';
import { sampleNode } from '@zilo/pose3d-pose/sample/sampleNode';
import type { ClipTime } from '@zilo/pose3d-pose/time/timeTypes';

/**
 * `sampleNode` per node into `out`; `frameKey` per decision 19 with each node's frame-animation counter from
 * `frameAnimTicks` (21.2, absent = 0); a parent override survives only on flex nodes.
 */
export function sampleLocals(channels: ClipChannels, time: ClipTime, out: LocalPose, frameAnimTicks?: Readonly<Record<string, number>>): LocalPose {
  const { rig, clip } = channels;
  out.forEach((local, i) => {
    sampleNode(channels, i, time, local);
    if (rig.flex[i] !== 1) local.parent = -1;
    const name = rig.names[i] ?? '';
    local.frameKey = nodeFrameKey(clip.tracks?.[name], rig.frameAnim[i] ?? null, time, frameAnimTicks?.[name] ?? 0);
  });
  return out;
}
